/**
 * Manage listType data
 */
import Ajax from '@/lib/ajax_wrapper'

const LIST_TYPE_PATH = '/admin/list_types'

/**
 * Read paginated companies
 *
 * @returns {promise}
 */
export function readListTypesData() {
  return Ajax.request({
    url: LIST_TYPE_PATH
  })
}

/**
 * Create a listType
 *
 * @param {object} listType
 * @param {string} listType.name
 *
 * @returns {promise}
 */
export function createListTypeData(listType) {
  return Ajax.request({
    url: LIST_TYPE_PATH,
    method: 'POST',
    data: {
      list_type: listType
    }
  })
}

/**
 * Read a listType
 *
 * @param {string} id
 *
 * @returns {promise}
 */
export function readListTypeData(id) {
  return Ajax.request({
    url: `${LIST_TYPE_PATH}/${id}`
  })
}

/**
 * Update a listType
 *
 * @param {string} id
 * @param {object} listType
 * @param {string} listType.name
 *
 * @returns {promise}
 */
export function updateListTypeData(id, listType) {
  return Ajax.request({
    url: `${LIST_TYPE_PATH}/${id}`,
    method: 'PATCH',
    data: {
      list_type: listType
    }
  })
}

/**
 * Delete a listType
 *
 * @param {string} id
 *
 * @returns {promise}
 */
export function deleteListTypeData(id) {
  return Ajax.request({
    url: `${LIST_TYPE_PATH}/${id}`,
    method: 'DELETE'
  })
}
